module.exports = __webpack_public_path__ + "img/ditan_yj_wenyanming.26ccb525.jpg";